import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  exportReceive(URL, header, success, error) {
    Vue.axios.get(URL + 'receiveexport', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  searchReceive(URL, header, success, error) {
    Vue.axios.get(URL + 'receive', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addReceive(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'receive', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editReceive(URL, obj, header, success, error) {
    Vue.axios.put(URL + 'receive', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeReceive(URL, header, success, error) {
    Vue.axios.delete(URL + 'receive', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveByID(URL, header, success, error) {
    Vue.axios.get(URL + 'receivebyid', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSuplierReceive(URL, header, success, error) {
    Vue.axios.get(URL + 'receive/suplier', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDockStore(URL, header, success, error) {
    Vue.axios.get(URL + 'receive/dock', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPartStore(URL, header, success, error) {
    Vue.axios.get(URL + 'receive/partstore', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveSerial(URL, header, success, error) {
    Vue.axios.get(URL + 'receiveserial', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveDetail(URL, header, success, error) {
    Vue.axios.get(URL + 'receivedetail', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveDetailExport(URL, header, success, error) {
    Vue.axios.get(URL + 'receivedetailexport', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveDetailByID(URL, header, success, error) {
    Vue.axios.get(URL + 'receivedetailbyid', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addReceiveDetail(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'receivedetail', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editReceiveDetail(URL, obj, header, success, error) {
    Vue.axios.put(URL + 'receivedetail', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeReceiveDetail(URL, header, success, error) {
    Vue.axios.delete(URL + 'receivedetail', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/receive.js